module.exports = __webpack_public_path__ + "img/transformationRenovation.ef65e4f7.jpg";